export enum ContainerStatus {
    Provisioning = 0,
    Pending = 1,
    Running = 2,
    Stopped = 3,
    Deactivating = 4,
    Stopping = 5,
    Deprovisioning = 6
}